export default "20260922.2 \r\n"